export default __webpack_public_path__ + "static/media/1_end_ico.b8344d6f.svg";